import { DateConverter } from '@shared/entities/converters/date-converter';
import { Entity } from '@shared/entities/entity';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Machine')
export class Machine extends Entity {
  @JsonProperty('serialNumber', String, true)
  public serialNumber?: string = undefined;
  @JsonProperty('assetId', String, true)
  public override id?: string = undefined;
  @JsonProperty('assetName', String, true)
  public assetName?: string = undefined;
  @JsonProperty('installDate', DateConverter, true)
  public installDate?: Date = undefined;
  @JsonProperty('typology', String, true)
  public typology?: string = undefined;
  @JsonProperty('location', String, true)
  public location?: string = undefined;
  @JsonProperty('locationId', String, true)
  public locationId?: string = undefined;
  @JsonProperty('accountId', String, true)
  public accountId?: string = undefined;
  @JsonProperty('accountName', String, true)
  public accountName?: string = undefined;
  @JsonProperty('statusTS', DateConverter, true)
  public statusTS?: Date = undefined;
  @JsonProperty('statusValue', String, true)
  public statusValue?: string = undefined;
  @JsonProperty('status', String, true)
  public status?: string = undefined;
  @JsonProperty('alarmMessage', String, true)
  public alarmMessage?: string = undefined;
  @JsonProperty('alarmTs', DateConverter, true)
  public alarmTs?: Date = undefined;
  @JsonProperty('alarmComponent', String, true)
  public alarmComponent?: string = undefined;
  @JsonProperty('alarmType', String, true)
  public alarmType?: string = undefined;
  @JsonProperty('address', String, true)
  public address?: string = undefined;
}
